import { component } from 'picoapp'
import { addVariant, addItemById } from '@/lib/cart.js'
import '@/lib/jquery-global.js';

export default component((node, ctx) => {
  const json = JSON.parse(node.querySelector('.js-product-json').innerHTML)
  const form = node.querySelector('form')


  let h = jQuery('.slater-product__info--inner').outerHeight()
  jQuery('.slater-product__info').css('min-height', h)

  const { selectedOrFirstAvailableVariant, product } = json
  let currentVariant = product.variants.filter(v => v.id === selectedOrFirstAvailableVariant)[0]

  async function addProducts(e, form) {
    e.preventDefault()

    let to = '';
    let from = '';
    let message = '';

    if (node.querySelector('.gift_input_to')) {
      to = node.querySelector('.gift_input_to').value;
    }

    if (node.querySelector('.gift_input_from')) {
      from = node.querySelector('.gift_input_from').value;
    }

    if (node.querySelector('.gift_input_message')) {
      message = node.querySelector('.gift_input_message').value;
    }

    let has_gift = false

    if ((to.length > 0) || (from.length > 0) || (message.length > 0)) {
      has_gift = true
    }

    // console.log(has_gift)

    currentVariant = product.variants.filter(v => v.id === parseInt(form.elements.id.value))[0]
    
    if (has_gift) {
      await $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: $(form).serialize(),
        success: function() {
          console.log('succeeded!');
        },
        error: function() {
          console.log('failed!');
        }
      });
    } else {

      
      await addVariant(currentVariant, form.elements.quantity.value);
    }

    // let include_gift_wrap = document.getElementById('gift_wrap').checked;

    // if (include_gift_wrap) {
    //   await addItemById('34541701988507', 1);
    // } else {
    //   await addItemById('34541701988507', 0);
    // }


    gtag("event", "add_to_cart",
        {
          variant: currentVariant.id,
          
        }
      )

  }


  form.addEventListener('submit', (e) => { addProducts(e, form) });
    
    // currentVariant = product.variants.filter(v => v.id === parseInt(form.elements.id.value))[0]

    // addVariant(currentVariant, form.elements.quantity.value)

    // console.log('add gift wrap if that box is checked')


    // console.log(json)
  // })

  if (document.querySelectorAll('.js-add-upsell')) {
    let upsell_items = document.querySelectorAll('.js-add-upsell')
  
    upsell_items.forEach((elem) => {
      elem.addEventListener('click', e => {

        let upsell_id = elem.dataset.variant;
        addItemById(upsell_id, 1);

      });
    })
  }

  

  var prevScrollpos = window.pageYOffset;
  var body = document.body;

  var sizeScrollPos = document.querySelector('.js-sizes').offsetTop;

  window.onscroll = () => {
    var currentScrollPos = window.pageYOffset;

    if (currentScrollPos > sizeScrollPos) {
      body.classList.add('product--scrolled');
    } else {
      body.classList.remove('product--scrolled');
    }

    prevScrollpos = currentScrollPos;
  }


  jQuery('.js-ff-size-toggle').click(function () {
    jQuery('.product-options-inner').toggleClass('sizes-open')
    jQuery('.js-ff-size-toggle').toggleClass('active')
  })

  
  

})


class CardComponent extends HTMLElement {
  constructor() {
    super()

    this.cards = this.querySelectorAll('.js-card')
    this.buttons = this.querySelectorAll('.js-select-variant')
    

    for (const button of this.buttons) {
      button.addEventListener('click', (e) => {
        this.removeActive()
        button.classList.add('active')
        
        const selected_cards = Array.from(this.cards).filter(card => card.dataset.id == button.dataset.id)

        for (const selected of selected_cards) {
          selected.classList.add('active')
        }
      })
    }

    this.buttons[0].click()
  }

  removeActive() {
    for (const card of this.cards) {
      card.classList.remove('active')
    }

    for (const button of this.buttons) {
      button.classList.remove('active')
    }
  }

}

customElements.define('card-component', CardComponent)



class BagComponent extends HTMLElement {
  constructor() {
    super()

    this.radios = this.querySelectorAll('.js-radio')
    this.bag_thumbnails = this.querySelector('.js-bag-thumbnails')    

    for (const radio of this.radios) {
      radio.addEventListener('change', (e) => {

        if (radio.value == 'The Lunch Kit') {
          this.bag_thumbnails.classList.add('active')
        } else {
          this.bag_thumbnails.classList.remove('active')
        }
      })
    }
    
  }

}

customElements.define('bag-component', BagComponent)


class ReturnToTopComponent extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('click', (e) => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    })
  }
}

customElements.define('return-to-top-component', ReturnToTopComponent)